module.exports = __webpack_public_path__ + "img/search.db7e7a37.svg";